module.exports = __webpack_public_path__ + "assets/b43.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b43.png
// module id = 631
// module chunks = 0